/*
 *
 * RestaurantsList constants
 *
 */

/**
 * @desc {state level}
 */
export const DEFAULT_ACTION = '/RestaurantsList/DEFAULT_ACTION';
export const FETCH_RESTURANTLIST = '/RestaurantsList/FETCH_RESTURANTLIST';
export const FETCH_RESTURANTPAGE_SUCCESS = '/RestaurantsList/FETCH_RESTURANTPAGE_SUCCESS';
export const FETCH_RESTURANTLIST_ERROR = '/RestaurantsList/FETCH_RESTURANTLIST_ERROR';
export const FETCH_RESTURANTLIST_SUCCESS = '/RestaurantsList/FETCH_RESTURANTLIST_SUCCESS';

/**
 * @desc {component level}
 */
export const TEXT_NO_RESTAURANT = 'No Restaurants To Display';
export const DEFAULT_PRE_PAYLOAD = {
  sort: 'rating', // near_me
  order_by: 'desc', // 'desc'/'asc'
  deal_type: 'group',
  first_offset: 0,
  last_offset: 12,
};
// export const DEFAULT_PRE_SEARCH_PAYLOAD = {
//   get_type: 'explore',
// };

export const SORT_DROPDOWN = [
  { value: 0, label: 'Rating', data: { order_by: 'desc', sort: 'rating' } },
  { value: 1, label: 'Price:High to Low', data: { order_by: 'desc', sort: 'cost' } },
  { value: 2, label: 'Price:Low to High', data: { order_by: 'asc', sort: 'cost' } },
];

export const FILTER_CATEGORY = [{ filterName: 'Bars and Lounges' },
  { filterName: 'Buffet' },
  { filterName: 'Cafes' },
  { filterName: 'Fine Dining' },
  { filterName: 'Casual Dining' },
  // { filterName: 'Chinese' },
  // { filterName: 'Italian' }
];

export const CONSTRUCT_MOBILE_FILTER_KEYS = [
  {
    filterTitle: 'Category',
    payloadKey: 'category',
    isActive: true,
    index: 0,
  },
  {
    filterTitle: 'Locations',
    payloadKey: 'locations',
    isActive: false,
    index: 1,
  },
  {
    filterTitle: 'Deal Type',
    payloadKey: 'tag_types',
    isActive: false,
    index: 2,
  },
  {
    filterTitle: 'Collections',
    payloadKey: 'tag_types',
    isActive: false,
    index: 3,
  },
  {
    filterTitle: 'Cuisines',
    payloadKey: 'cuisines',
    isActive: false,
    index: 4,
  },
];

export const SWITCH_PAYLOADS = ({ filterCategory, locationFilters, dealFilter, collectionFilter, cuisinesFilters }, payloadKey, filterTitle, callback) => {
  switch (payloadKey) {
    case 'category':
      callback(payloadKey, filterCategory);
      break;
    case 'locations':
      callback(payloadKey, locationFilters);
      break;
    case 'tag_types':
      if (filterTitle === 'Deal Type') {
        callback(payloadKey, dealFilter, 'Deal Type');
      } else if (filterTitle === 'Collections') {
        callback(payloadKey, collectionFilter, 'Collections');
      }
      break;
    case 'cuisines':
      callback(payloadKey, cuisinesFilters);
      break;
    default:
      break;
  }
};
export const MAKE_FILTER_TRACKING_LABEL = (array) => {
  let result = [];
  for (let i = 0; i < array.length; i += 1) {
    result = result.concat(array[i]);
  }
  return `<${result.join('> - <')}>`;
};




// WEBPACK FOOTER //
// client/containers/RestaurantsList/constants.js